(function () {
    'use strict';
    var m = angular.module('app');
    m.service('sideMenuManager', ["$q", "$timeout", "path", "avananUserDao", "$route", "feature", "idleManager", "configDao", "trialExpiredModal", "autologinHelper", "$window", "$injector", "$rootScope", "routeHelper", function ($q, $timeout, path, avananUserDao, $route, feature, idleManager, configDao, trialExpiredModal, autologinHelper, $window, $injector, $rootScope, routeHelper) {
        var data = {
            menus: [],
            updateTick: 1000,
            menuCounter: 1
        };
        var dataUpdateHandle = null;
        function updateMenus() {
            $q.all([
                path('main').directive('main-menu').jsonRel('main-menu').retrieve(),
                configDao.getTrialExpirationDays().run().then(function (response) {
                    return response;
                }, function () {
                    return $q.when(null);
                }),
                feature.init(true, true)
            ]).then(function (responses) {
                data = $.extend(data, responses[0].data);
                var deploymentConfig = responses[1];
                isManagedService = deploymentConfig && deploymentConfig.is_managed_service || false;
                hideChatMessages = deploymentConfig && deploymentConfig.always_hide_chat_messages || false;
                if (deploymentConfig) {
                    if (deploymentConfig.deployment_mode === 'demo') {
                        trialMessage = 'You\'re running on demo version.';
                        trialMessageLabel = 'Demo';
                    } else {
                        var trialExpirationDays = deploymentConfig.pocExpiresInDays;
                        if (!_(trialExpirationDays).isNull()) {
                            if (trialExpirationDays < 0) {
                                if (currentUser && !currentUser.hidden && !feature.checkpointTheme) {
                                    avananUserDao.logout();
                                    trialExpiredModal.show().then(function () {
                                        $rootScope.$broadcast('$logout', { reason: 'trial expired' });
                                    });
                                }
                                trialMessageLabel = 'Expired';
                                trialMessage = 'Your evaluation license has expired';
                            } else {
                                trialMessage = 'Trial License - Expires in ' + trialExpirationDays + ' day' + (trialExpirationDays !== 1 ? 's' : '');
                                if (trialExpirationDays < 14) {
                                    trialMessageLabel = trialExpirationDays + ' day' + (trialExpirationDays !== 1 ? 's' : '') + ' left';
                                } else {
                                    trialMessageLabel = 'Trial';
                                }
                            }
                        } else {
                            trialMessageLabel = '';
                            trialMessage = '';
                        }
                    }
                }
                $rootScope.gotTrialExpirationDays = true;
                data.menuCounter++;
                if (data.menuCounter > 2000000000) {
                    data.menuCounter = 1;
                }
            }, function () {
                dataUpdateHandle = $timeout(updateMenus, 1000);
            });
        }
        dataUpdateHandle = $timeout(updateMenus);
        function inAuthedArea() {
            return $route.current && $route.current.name != 'auth' && $route.current.name != 'authorize-error';
        }
        var hidden = false;
        var mini = false;
        var display = false;
        var fixed = true;
        var fullscreen = true;
        var currentUser = {};
        var customIconRandom;
        var logoIsCustom;
        var navigationPath = [];
        var trialMessage = '';
        var routeClass = '';
        var trialMessageLabel = '';
        var isManagedService = false;
        var hideChatMessages = false;
        var v2ActiveMenu = null;
        var limitedLicense = false;
        var sideMenuManager = {
            versionCheck: {
                timer: null,
                updateTick: 60000,
                cancelPromise: null,
                inProgress: false,
                requestStart: null,
                requestTimeout: 60000
            },
            versionRecheck: function () {
                if (inAuthedArea) {
                    if (!sideMenuManager.versionCheck.inProgress || new Date() - sideMenuManager.versionCheck.requestStart > sideMenuManager.versionCheck.requestTimeout) {
                        if (sideMenuManager.versionCheck.cancelPromise) {
                            sideMenuManager.versionCheck.cancelPromise.resolve();
                        }
                        sideMenuManager.versionCheck.requestStart = new Date();
                        sideMenuManager.versionCheck.inProgress = true;
                        sideMenuManager.versionCheck.cancelPromise = $q.defer();
                        var doNotAutoLogout = !!$rootScope.runInIframe;
                        avananUserDao.current(doNotAutoLogout).timeout(sideMenuManager.versionCheck.cancelPromise).then(function (response) {
                            if (response.data.do_logout) {
                                console.log('Log out by do_logout');
                                routeHelper.redirectTo('auth', { page: 'login' });
                            }
                            if (response.data.disableMsg) {
                                feature.init().then(function () {
                                    if (feature.checkpointTheme && autologinHelper.enabled()) {
                                        window.localStorage.setItem('reloadByNewVersion', true);
                                        $window.location.reload(true);
                                    } else {
                                        $injector.get('modals').alert(response.data.disableMsg, {
                                            title: 'Alert',
                                            closeText: 'Reload',
                                            disableCloseX: true,
                                            backdrop: 'static',
                                            keyboard: false
                                        }).then(function () {
                                            $window.location.reload(true);
                                        });
                                    }
                                });
                            }
                            sideMenuManager.versionCheck.cancelPromise = null;
                            sideMenuManager.versionCheck.inProgress = false;
                        }, function () {
                            sideMenuManager.versionCheck.cancelPromise = null;
                            sideMenuManager.versionCheck.inProgress = false;
                        });
                    }
                }
                sideMenuManager.versionCheck.timer = $timeout(sideMenuManager.versionRecheck, sideMenuManager.versionCheck.updateTick);
            },
            toggleHide: function () {
                hidden = !hidden;
            },
            hidden: function (newState) {
                if (_(newState).isBoolean()) {
                    hidden = newState;
                }
                return hidden;
            },
            hiddenOverflow: function () {
                return !!($route.current && $route.current.hiddenOverflow);
            },
            noPaddings: function () {
                return !!($route.current && $route.current.noPaddings);
            },
            toggleMini: function () {
                mini = !mini;
            },
            mini: function (newState) {
                if (_(newState).isBoolean()) {
                    mini = newState;
                }
                return mini;
            },
            toggleDisplay: function () {
                display = !display;
            },
            display: function (newState) {
                if (_(newState).isBoolean()) {
                    display = newState;
                }
                return display;
            },
            toggleFixed: function () {
                fixed = !fixed;
            },
            fixed: function (newState) {
                if (_(newState).isBoolean()) {
                    fixed = newState;
                }
                return fixed;
            },
            getMenus: function () {
                return data.menus;
            },
            updateMenus: function () {
                data.updateTick = 1000;
                $timeout.cancel(dataUpdateHandle);
                dataUpdateHandle = $timeout(updateMenus);
            },
            fullscreen: function (newState) {
                if (_(newState).isBoolean()) {
                    fullscreen = newState;
                }
                return fullscreen;
            },
            routeClass: function (newClass) {
                if (_(newClass).isString()) {
                    routeClass = newClass;
                }
                return routeClass;
            },
            currentUser: function (newUser) {
                if (_(newUser).isObject()) {
                    if (!currentUser || currentUser.email !== newUser.email) {
                        updateMenus();
                    }
                    currentUser = newUser;
                }
                currentUser.admin = currentUser.role == 'admin';
                return currentUser;
            },
            customIcon: function (refresh) {
                if (refresh || !customIconRandom) {
                    logoIsCustom = false;
                    customIconRandom = '' + Math.random();
                }
                return '/api/v1/custom_icon?' + customIconRandom;
            },
            logoIsCustom: function (newValue) {
                if (!_(newValue).isUndefined()) {
                    logoIsCustom = newValue;
                }
                if (feature.lastlineTheme) {
                    logoIsCustom = true;
                }
                return logoIsCustom;
            },
            treeNavigationPath: function (newPath) {
                if (!_(newPath).isUndefined()) {
                    navigationPath = newPath;
                }
                return navigationPath;
            },
            trialMessage: function () {
                return trialMessage;
            },
            trialMessageLabel: function () {
                return trialMessageLabel;
            },
            isManagedService: function () {
                //Use this flag to display Avanan logo premium
                return isManagedService;
            },
            hideChatMessages: function () {
                return hideChatMessages;
            },
            sideMenuHeight: function () {
                var baseTopSize = 198;
                var trialSize = 50;
                return 'calc(100% - ' + (baseTopSize + (trialMessage ? trialSize : 0)) + 'px)';
            },
            menuStateCounter: function () {
                return data.menuCounter;
            },
            v2FullTop: function () {
                return feature.checkpointTheme;
            },
            subMenuOnTheRight: function () {
                return feature.checkpointTheme;
            },
            activeMenu: function (newMenu) {
                if (!_(newMenu).isUndefined()) {
                    v2ActiveMenu = newMenu;
                }
                return v2ActiveMenu;
            },
            rightMenuVisible: function () {
                return sideMenuManager.subMenuOnTheRight() && v2ActiveMenu && v2ActiveMenu.submenus && v2ActiveMenu.submenus.length;
            },
            limitedLicense: function (newValue) {
                if (!_(newValue).isUndefined()) {
                    limitedLicense = newValue;
                }
                return limitedLicense;
            }
        };
        return sideMenuManager;
    }]);
}());